import React, { useState, useRef, useEffect } from "react";
import { API_URLS } from "../apiUrl";
import BoroughDropdown from "../pages/customHooks/boroughDropdown";
import WardDropdown from "../pages/customHooks/wardDropdown";
import StreetDropdown from "../pages/customHooks/streetdropdown";
import CryptoJS from "crypto-js";
import axiosInstance from "../components/axiosInstance";

const SurveyorEdit = ({ isOpen, closeModal, municipalityId, surveyorName, surveyorId, loginUserName, password, boroughId, wardId, streetId }: any) => {

  const [formData, setFormData] = useState<any>({
    surveyer_id: surveyorId,
    municipality_id: municipalityId,
    survyer_name: surveyorName || "",
    login_user_name: loginUserName || "",
    password: "",
    confirm_password: "",
    added_by: 2,
    borough_ids: "",
    ward_ids: "",
    street_ids: "",
  });

  useEffect(() => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      surveyer_id: surveyorId,
      survyer_name: surveyorName || prevFormData.survyer_name,
      login_user_name: loginUserName || prevFormData.login_user_name,
      password: "",
      borough_ids: boroughId || "",
      ward_ids: wardId || "",
      street_ids: streetId || "",
      municipality_id: municipalityId,
    }));
  }, [surveyorName, loginUserName, password, boroughId, wardId, streetId, municipalityId]);

  const [errors, setErrors] = useState<any>({});
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [dataExistMessage, setDataExistMessage] = useState<string>("");
  const [dataFailedMessage, setDataFailedMessage] = useState<string>("");

  const formRef = useRef<HTMLFormElement>(null);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | any
  ) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = (): boolean => {
    const newErrors: any = {};

    if (formData.password && formData.confirm_password && formData.password !== formData.confirm_password) {
      newErrors.confirm_password = "Passwords do not match.";
    }

    if (formData.password && !formData.confirm_password) {
      newErrors.confirm_password = "Confirm password is required.";
    }

    if (formData.password) {
      const passwordPattern = /^(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{5,}$/;
      if (!passwordPattern.test(formData.password)) {
        newErrors.password = "Password must be at least 5 characters long, contain at least one special character, and one number.";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setFormData({
      survyer_name: "",
      login_user_name: "",
      password: "",
      confirm_password: "",
      borough_ids: "",
      ward_ids: "",
      street_ids: "",
      municipality_id: municipalityId,
      added_by: ""
    });
    setErrors({
      survyer_name: "",
      login_user_name: "",
      password: "",
      confirm_password: "",
      borough_ids: "",
      ward_ids: "",
      street_ids: "",
      municipality_id: municipalityId,
      added_by: ""
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    let updatedPassword = formData.password;

    if (!formData.password && !formData.confirm_password) {
      updatedPassword = password;
    } else if (formData.password && formData.password !== formData.confirm_password) {
      setErrors({ confirm_password: "Passwords do not match." });
      return;
    }

    if (formData.password) {
      updatedPassword = CryptoJS.MD5(formData.password).toString();
    }

    const updatedFormData: any = {
      ...formData,
      password: updatedPassword,
      added_by: formData.added_by
    };

    const finalFormData = {
      ...updatedFormData,
      borough_ids: formData.borough_ids || boroughId,
      ward_ids: formData.ward_ids || wardId,
      street_ids: formData.street_ids || streetId
    };

    if (validateForm()) {
      const formDataToSend = new FormData();

      for (const key in finalFormData) {
        if (finalFormData[key]) {
          formDataToSend.append(key, finalFormData[key]);
        }
      }

      try {
        const response = await axiosInstance.post(`${API_URLS.UpdateSurveyor}`, formDataToSend);

        if (response.data.data.message) {
          setDataExistMessage(`${response.data.data.message}`);

          setTimeout(() => {
            resetForm();
            setDataExistMessage("");
            closeModal();
          }, 5000);
        } else if (response.data.message === "surveyer updated successfully") {
          setSuccessMessage("Surveyor updated successfully");
          setTimeout(() => {
            resetForm();
            setSuccessMessage("");
            closeModal();
          }, 5000);
        }

        setErrors({});
      } catch (error) {
        setDataFailedMessage("Surveyor Add failed.");
        setTimeout(() => {
          setDataFailedMessage("");
          resetForm();
        }, 5000);
      }
    }
  };

  const dropdownRef = useRef<any>(null);
  const dropdownRefWard = useRef<any>(null);
  const dropdownRefStreet = useRef<any>(null);

  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpenBorough(false);
    }

    if (dropdownRefWard.current && !dropdownRefWard.current.contains(event.target)) {
      setIsDropdownOpenWard(false);
    }

    if (dropdownRefStreet.current && !dropdownRefStreet.current.contains(event.target)) {
      setIsDropdownOpenStreet(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [
    setIsDropdownOpenBorough,
    isDropdownOpenBorough,
    ,
    boroughList,
    loadingBoroughList,
  ] = BoroughDropdown(municipalityId);

  const toggleDropdownBorough = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsDropdownOpenBorough((prev: any) => !prev);
  };

  const handleBoroughSelect = (e: any) => {
    const { value, checked } = e.target;

    setFormData((prevFormData: any) => {
      const currentBoroughIds = prevFormData.borough_ids || "";
      const newSelections = currentBoroughIds ? currentBoroughIds.split(",") : [];

      if (checked) {
        if (!newSelections.includes(value)) {
          newSelections.push(value);
        }
      } else {
        const index = newSelections.indexOf(value);
        if (index > -1) {
          newSelections.splice(index, 1);
        }
      }

      return {
        ...prevFormData,
        borough_ids: newSelections.join(","),
      };
    });
  };

  const toggleDropdownWard = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsDropdownOpenWard((prev: any) => !prev);
  };

  const [
    setIsDropdownOpenWard,
    isDropdownOpenWard,
    ,
    wardList,
    loadingWardList,
  ] = WardDropdown(municipalityId, formData.borough_ids);

  const handleWardSelect = (e: any) => {
    const { value, checked } = e.target;
    setFormData((prevFormData: any) => {
      const currentWardIds = prevFormData.ward_ids || "";
      const newSelections = currentWardIds ? currentWardIds.split(",") : [];

      if (checked) {
        if (!newSelections.includes(value)) {
          newSelections.push(value);
        }
      } else {
        const index = newSelections.indexOf(value);
        if (index > -1) {
          newSelections.splice(index, 1);
        }
      }

      return {
        ...prevFormData,
        ward_ids: newSelections.join(","),
      };
    });
    setIsDropdownOpenWard(false);
  };

  const toggleDropdownStreets = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsDropdownOpenStreet((prev: any) => !prev);
  };

  const handleStreetSelect = (e: any) => {
    const { value, checked } = e.target;
    setFormData((prevFormData: any) => {
      const currentStreetIds = prevFormData.street_ids || "";
      const newSelections = currentStreetIds ? currentStreetIds.split(",") : [];

      if (checked) {
        if (!newSelections.includes(value)) {
          newSelections.push(value);
        }
      } else {
        const index = newSelections.indexOf(value);
        if (index > -1) {
          newSelections.splice(index, 1);
        }
      }

      return {
        ...prevFormData,
        street_ids: newSelections.join(","),
      };
    });
    setIsDropdownOpenWard(false);
  };

  const [
    setIsDropdownOpenStreet,
    isDropdownOpenStreet,
    ,
    streetList,
    loadingStreetList,
  ] = StreetDropdown(municipalityId, formData.ward_ids);

  if (!isOpen) return null;

  const handleOutsideClick = (e: any) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Helper function to safely split and check includes
  const isSelected = (ids: string | null | undefined, id: number | string): boolean => {
    if (!ids) return false;
    return ids.split(",").includes(id.toString());
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center" onClick={handleOutsideClick}>
      <div className="bg-white p-6 rounded-lg shadow-lg w-[740px] relative" onClick={(e) => e.stopPropagation()}>
        <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Edit Surveyor</h1>
        <form ref={formRef} onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
            <div>
              <label htmlFor="survyer_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Surveyor Name <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                id="survyer_name"
                name="survyer_name"
                value={formData.survyer_name}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                disabled
              />
              {errors.survyer_name && (
                <p className="text-sm text-red-600 mt-1">{errors.survyer_name}</p>
              )}
            </div>

            <div>
              <label htmlFor="login_user_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Login User Name <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                id="login_user_name"
                name="login_user_name"
                value={formData.login_user_name}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                disabled
              />
              {errors.login_user_name && (
                <p className="text-sm text-red-600 mt-1">{errors.login_user_name}</p>
              )}
            </div>

            <div className="relative z-[4]">
              <label htmlFor="borough_ids" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Borough <span className="text-red-600">*</span>
              </label>
              <div className="relative z-[4]" ref={dropdownRef}>
                <button
                  onClick={toggleDropdownBorough}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5 pr-3 text-left flex items-center"
                  type="button"
                >
                  {formData.borough_ids && formData.borough_ids.length > 0
                    ? boroughList
                      .filter((borough: any) => formData.borough_ids.split(",").includes(borough.borough_primary_id.toString()))
                      .map((borough: any) => borough.borough_name)
                      .join(", ")
                    : "Select Borough"}

                  <i className="ri-arrow-down-s-line ri-lg ml-auto"></i>
                </button>

                {isDropdownOpenBorough && (
                  <div className="h-[150px] overflow-y-auto absolute top-full w-full bg-gray-50 border border-gray-300 rounded-lg p-2.5 dark:bg-gray-700 dark:border-gray-600">
                    {boroughList.map((borough: any) => (
                      <div key={borough.borough_primary_id} className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          id={`borough_${borough.borough_primary_id}`}
                          value={borough.borough_primary_id}
                          checked={isSelected(formData.borough_ids, borough.borough_primary_id)}
                          onChange={handleBoroughSelect}
                          className="text-blue-600"
                        />
                        <label htmlFor={`borough_${borough.borough_primary_id}`} className="text-sm text-gray-900 dark:text-white">
                          {borough.borough_name}
                        </label>
                      </div>
                    ))}
                    {loadingBoroughList && <p>Loading...</p>}
                  </div>
                )}
              </div>
              {errors.borough_ids && (
                <p className="text-red-600 text-sm mt-1">{errors.borough_ids}</p>
              )}
            </div>

            <div>
              <label htmlFor="ward_tbl_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Ward <span className="text-red-600">*</span>
              </label>
              <div className="relative" ref={dropdownRefWard}>
                <button
                  onClick={toggleDropdownWard}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5 pr-3 text-left flex items-center"
                  type="button"
                >
                  {formData.ward_ids && formData.ward_ids.length > 0
                    ? wardList
                      .filter((ward: any) => formData.ward_ids.split(",").includes(ward.ward_primary_id.toString()))
                      .map((ward: any) => ward.ward_no)
                      .join(", ")
                    : "Select Ward"}

                  <i className="ri-arrow-down-s-line ri-lg ml-auto"></i>
                </button>

                {isDropdownOpenWard && (
                  <div className="absolute top-full w-full bg-gray-50 border border-gray-300 rounded-lg p-2.5 dark:bg-gray-700 dark:border-gray-600 max-h-[200px] overflow-y-auto">
                    {wardList.map((ward: any) => (
                      <div key={ward.ward_primary_id} className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          id={`ward_${ward.ward_primary_id}`}
                          value={ward.ward_primary_id}
                          checked={isSelected(formData.ward_ids, ward.ward_primary_id)}
                          onChange={handleWardSelect}
                          className="text-blue-600"
                        />
                        <label htmlFor={`ward_${ward.ward_primary_id}`} className="text-sm text-gray-900 dark:text-white">
                          {ward.ward_no}
                        </label>
                      </div>
                    ))}
                    {loadingWardList && <p>Loading...</p>}
                  </div>
                )}
              </div>
              {errors.ward_ids && (
                <p className="text-red-600 text-sm mt-1">{errors.ward_ids}</p>
              )}
            </div>

            <div>
              <label htmlFor="street_ids" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Streets <span className="text-red-600">*</span>
              </label>
              <div className="relative" ref={dropdownRefStreet}>
                <button
                  onClick={toggleDropdownStreets}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5 pr-3 text-left flex items-center"
                  type="button"
                >
                  {formData.street_ids && formData.street_ids.length > 0
                    ? streetList
                      .filter((street: any) => formData.street_ids.split(",").includes(street.street_primary_id.toString()))
                      .map((street: any) => street.street_name)
                      .join(", ")
                    : "Select Street"}

                  <i className="ri-arrow-down-s-line ri-lg ml-auto"></i>
                </button>

                {isDropdownOpenStreet && (
                  <div className="absolute top-full w-full bg-gray-50 border border-gray-300 rounded-lg p-2.5 dark:bg-gray-700 dark:border-gray-600 max-h-[200px] overflow-y-auto">
                    {streetList.map((street: any) => (
                      <div key={street.street_primary_id} className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          id={`street_${street.street_primary_id}`}
                          value={street.street_primary_id}
                          checked={isSelected(formData.street_ids, street.street_primary_id)}
                          onChange={handleStreetSelect}
                          className="text-blue-600"
                        />
                        <label htmlFor={`street_${street.street_primary_id}`} className="text-sm text-gray-900 dark:text-white">
                          {street.street_name}
                        </label>
                      </div>
                    ))}
                    {loadingStreetList && <p>Loading...</p>}
                  </div>
                )}
              </div>
              {errors.street_ids && (
                <p className="text-red-600 text-sm mt-1">{errors.street_ids}</p>
              )}
            </div>

            <div className="lg:col-span-2"><hr /></div>

            <div className="col-span-2"><label className="text-xl font-semibold">Change Password</label></div>

            <div>
              <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder='E.g. Test@1234'
              />
              {errors.password && (
                <p className="text-sm text-red-600 mt-1">{errors.password}</p>
              )}
            </div>

            <div>
              <label htmlFor="confirm_password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Confirm Password
              </label>
              <input
                type="password"
                id="confirm_password"
                name="confirm_password"
                value={formData.confirm_password}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder='E.g. Test@1234'
              />
              {errors.confirm_password && (
                <p className="text-sm text-red-600 mt-1">{errors.confirm_password}</p>
              )}
            </div>

            <div className="sm:col-span-2">
              <button
                type="submit"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                Update
              </button>
            </div>
          </div>
        </form>

        {successMessage && (
          <div className="mt-4 p-4 bg-green-600 text-white rounded-lg flex justify-between items-center">
            <span>{successMessage}</span>
            <button
              onClick={() => setSuccessMessage('')}
              className="ml-4 text-white font-bold text-lg focus:outline-none"
            >
              &times;
            </button>
          </div>
        )}

        {dataExistMessage && (
          <div className="mt-4 p-4 bg-yellow-500 text-black rounded-lg flex justify-between items-center">
            <span>{dataExistMessage}</span>
            <button
              onClick={() => setDataExistMessage('')}
              className="ml-4 text-black font-bold text-lg focus:outline-none"
            >
              &times;
            </button>
          </div>
        )}

        {dataFailedMessage && (
          <div className="mt-4 p-4 bg-red-500 text-black rounded-lg flex justify-between items-center">
            <span>{dataFailedMessage}</span>
            <button
              onClick={() => setDataFailedMessage('')}
              className="ml-4 text-black font-bold text-lg focus:outline-none"
            >
              &times;
            </button>
          </div>
        )}

        <button
          onClick={closeModal}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          <i className="ri-close-line"></i>
        </button>
      </div>
    </div>
  );
};

export default SurveyorEdit;